// Imports
import availableSubscriptionSizes from './available-subscription-sizes';
import isValidSubscriptionPlan from './is-valid-subscription-plan';
import specialSizes from './special-sizes';


/** Determines whether a particular size is a valid subscription size */
export default function isValidSubscriptionSize(options: { size: number; plan: number }) {
	// Handle unexpected plan numbers
	if (!isValidSubscriptionPlan(options.plan)) {
		throw new Error(`Unexpected invalid plan (${options.plan})`);
	}
	
	
	// Return
	return [...availableSubscriptionSizes(options.plan), ...Object.values(specialSizes)].includes(options.size);
}
